import * as React from 'react';

export interface IIcon {
  /** Icon name */
  name: IconNames;
  /**
   * –
   * @default 24
   */
  size?: number;
  /**
   * Tachyons color class
   * @default blue
   */
  color?: string;
  className?: string;
  /**
   * The size of the SVG viewbox
   * @default 24
   */
  viewBox?: number;
}

const Icon: React.FunctionComponent<IIcon> = ({
  className,
  color = 'blue',
  name,
  size = 24,
  viewBox = 24
}) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${viewBox} ${viewBox}`}
    className={`overflow-visible fill-${color} ${className}`}
    width={size}
    height={size}
  >
    {name === 'account' && (
      <path
        d="M14.3,12.3c1.3-0.8,2.2-2.2,2.2-3.8C16.5,6,14.5,4,12,4S7.5,6,7.5,8.5c0,1.6,0.9,3.1,2.2,3.8
      C6.4,13.3,4,16.4,4,20h16C20,16.4,17.6,13.3,14.3,12.3z M8.5,8.5C8.5,6.6,10.1,5,12,5s3.5,1.6,3.5,3.5S13.9,12,12,12
      S8.5,10.4,8.5,8.5z M12,13c3.5,0,6.4,2.6,6.9,6H5.1C5.6,15.6,8.5,13,12,13z"
      />
    )}

    {name === 'arrow' && (
      <polygon points="16.4,10.6 15.6,11.4 18.8,14.5 10,14.5 10,15.5 18.8,15.5 15.6,18.6 16.4,19.4 20.7,15 " />
    )}

    {name === 'calendar' && (
      <path
        d="M18.5,9.6V8.4h-1v1.1h-5V8.4h-1v1.1H9V13v1v7.5h12V14v-1V9.6H18.5z M20,20.6H10v-6.5h10V20.6z M10,13.1v-2.5
	h1.5v0.9h1v-0.9h5v0.9h1v-0.9H20v2.5H10z"
      />
    )}

    {name === 'caret-left' && (
      <path d="M16.707,4.707l-2.658,2.658l-4.635,4.635l7.293,7.293l-1.414,1.414l-8.707,-8.707l6.049,-6.049l2.658,-2.658c0.471,0.471 0.943,0.943 1.414,1.414Z" />
    )}

    {name === 'check' && (
      <polygon points="11.171 21.895 4.2 12.6 5.8 11.4 10.829 18.105 18.105 3.553 19.895 4.447 11.171 21.895" />
    )}

    {name === 'clock' && (
      <g>
        <path
          d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,21c-5,0-9-4-9-9s4-9,9-9s9,4,9,9
		S17,21,12,21z"
        />
        <polygon points="12.5,6 11.5,6 11.5,12.2 15.9,16.6 16.6,15.9 12.5,11.8" />
      </g>
    )}

    {name === 'close' && (
      <polygon
        points="18.5,6.6 17.4,5.5 12,10.9 6.6,5.5 5.5,6.6 10.9,12 5.5,17.4 6.6,18.5 12,13.1 17.4,18.5 18.5,17.4
      13.1,12 "
      />
    )}

    {name === 'close-lg' && (
      <polygon points="24,1 23,0 12,11 1,0 0,1 11,12 0,23 1,24 12,13 23,24 24,23 13,12 " />
    )}

    {name === 'dots' && (
      <>
        <path d="M14,12c0,-1.104 -0.896,-2 -2,-2c-1.104,0 -2,0.896 -2,2c0,1.104 0.896,2 2,2c1.104,0 2,-0.896 2,-2" />
        <path d="M8.5,12c0,-1.104 -0.896,-2 -2,-2c-1.104,0 -2,0.896 -2,2c0,1.104 0.896,2 2,2c1.104,0 2,-0.896 2,-2" />
        <path d="M19.5,12c0,-1.104 -0.896,-2 -2,-2c-1.104,0 -2,0.896 -2,2c0,1.104 0.896,2 2,2c1.104,0 2,-0.896 2,-2" />
      </>
    )}

    {name === 'edit' && (
      <g>
        <g>
          <path d="M8.6,18.8l-3.4-3.4L15.6,5.1l3.4,3.4L8.6,18.8z M7.3,15.4l1.3,1.3l8.3-8.3l-1.3-1.3L7.3,15.4z" />
        </g>
        <g>
          <g>
            <polygon points="3,21 3.9,16.2 7.8,20.1" />
          </g>
        </g>
        <rect
          x="18.3"
          y="2.2"
          transform="matrix(0.7071 -0.7071 0.7071 0.7071 2.0846 14.9223)"
          width="1.5"
          height="5.5"
        />
      </g>
    )}

    {name === 'filter' && <path d="M20,4H4l7,10.5V20h2V14.5ZM16.263,6,12,12.39441,7.73706,6Z" />}

    {name === 'home' && (
      <path
        d="M22.4,12.8L12,2.4L1.6,12.8l0.7,0.7l2.1-2.1v10.3h15V11.3l2.1,2.1L22.4,12.8z M14,20.6h-4v-9h4V20.6z
      M18.5,20.6H15v-10H9v10H5.5V10.3L12,3.8l6.5,6.5V20.6z"
      />
    )}

    {name === 'link' && (
      <g>
        <path
          d="M9.6,10.8c-1.1,0-2.2-0.4-3.1-1.3l1-1c1.1,1.1,3,1.1,4.1,0l2.1-2.1c1.1-1.1,1.1-3,0-4.1c-1.1-1.1-3-1.1-4.1,0
      		L7.5,4.4l-1-1l2.1-2.1c1.7-1.7,4.5-1.7,6.2,0s1.7,4.5,0,6.2l-2.1,2.1C11.8,10.4,10.7,10.8,9.6,10.8z"
        />
        <path
          d="M4.4,16c-1.1,0-2.2-0.4-3.1-1.3C0.5,13.9,0,12.8,0,11.6c0-1.2,0.5-2.3,1.3-3.1l2.1-2.1
      		c0.8-0.8,1.9-1.3,3.1-1.3s2.3,0.5,3.1,1.3l-1,1c-1.1-1.1-3-1.1-4.1,0L2.3,9.5c-0.6,0.6-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1
      		c1.1,1.1,3,1.1,4.1,0l2.1-2.1l1,1l-2.1,2.1C6.6,15.6,5.5,16,4.4,16z"
        />
      </g>
    )}

    {/* Viewbox: 16 */}
    {name === 'menu' && (
      <g>
        <rect y="4" width="16" height="1" />
        <rect y="11" width="16" height="1" />
      </g>
    )}

    {name === 'grid' && (
      <g>
        <path d="M9.5,5.5v4h-4v-4H9.5 M11,4H4v7h7V4L11,4z" />
        <path d="M9.5,14.5v4h-4v-4H9.5 M11,13H4v7h7V13L11,13z" />
        <path d="M18.5,14.5v4h-4v-4H18.5 M20,13h-7v7h7V13L20,13z" />
        <path d="M18.5,5.5v4h-4v-4H18.5 M20,4h-7v7h7V4L20,4z" />
      </g>
    )}

    {name === 'groups' && (
      <path
        d="M16,4c-1.5,0-2.8,0.4-4,1.1C10.8,4.4,9.5,4,8,4c-4.4,0-8,3.6-8,8s3.6,8,8,8c1.5,0,2.8-0.4,4-1.1
 c1.2,0.7,2.5,1.1,4,1.1c4.4,0,8-3.6,8-8S20.4,4,16,4z M8,19c-3.9,0-7-3.1-7-7s3.1-7,7-7c1.1,0,2.1,0.3,3.1,0.7C9.2,7.2,8,9.4,8,12
 s1.2,4.8,3.1,6.3C10.1,18.7,9.1,19,8,19z M12,6.3c1.8,1.3,3,3.4,3,5.7s-1.2,4.5-3,5.7c-1.8-1.3-3-3.4-3-5.7S10.2,7.5,12,6.3z M16,19
 c-1.1,0-2.1-0.3-3.1-0.7c1.9-1.5,3.1-3.7,3.1-6.3s-1.2-4.8-3.1-6.3C13.9,5.3,14.9,5,16,5c3.9,0,7,3.1,7,7S19.9,19,16,19z"
      />
    )}

    {name === 'hash' && (
      <path d="M20,10.333v-2H15.667V4h-2V8.333H10.333V4h-2V8.333H4v2H8.333v3.334H4v2H8.333V20h2V15.667h3.334V20h2V15.667H20v-2H15.667V10.333Zm-6.333,3.334H10.333V10.333h3.334Z" />
    )}

    {name === 'list' && (
      <g>
        <rect x="2" y="8.5" width="20" height="2" />
        <rect x="2" y="18.5" width="18" height="2" />
        <rect x="2" y="13.5" width="12" height="2" />
        <rect x="2" y="3.5" width="16" height="2" />
      </g>
    )}

    {name === 'minus' && <rect x="4" y="11" width="16" height="2" />}

    {name === 'new' && (
      <>
        <g>
          <circle cx="24" cy="24" r="24" />
        </g>
        <polygon
          fill="white"
          points="34,23.5 24.5,23.5 24.5,14 23.5,14 23.5,23.5 14,23.5 14,24.5 23.5,24.5 23.5,34 24.5,34 24.5,24.5 
      34,24.5 "
        />
      </>
    )}

    {name === 'new-small' && (
      <path
        d="M12,4c-4.4,0-8,3.6-8,8s3.6,8,8,8c4.4,0,8-3.6,8-8S16.4,4,12,4z M16,12.8h-3.2V16h-1.5v-3.2H8v-1.5h3.2V8h1.5
      	v3.2H16V12.8z"
      />
    )}

    {name === 'note' && (
      <>
        <rect x="7.283" y="6.532" width="9.434" height="1.5" />
        <rect x="7.283" y="13.272" width="9.434" height="1.5" />
        <rect x="7.283" y="9.902" width="9.434" height="1.5" />
        <path d="M20.087,1.891l-16.174,0l0,20.218l16.174,0l0,-20.218Zm-1.441,18.776l-13.292,0l0,-17.336l13.292,0l0,17.336Z" />
      </>
    )}

    {name === 'panel-toggle' && (
      <g>
        <polygon points="9.6,0.6 8.6,1.7 13.2,6.3 3.3,6.3 3.3,7.8 13.1,7.8 8.6,12.3 9.6,13.4 16,7 	" />
        <rect width="1.5" height="14" />
      </g>
    )}

    {name === 'paperclip' && (
      <path
        d="M12,21.8c-2.5,0-4.5-2-4.5-4.5v-9H9v9c0,1.7,1.3,3,3,3s3-1.3,3-3V5.6c0-1-0.8-1.9-1.9-1.9s-1.9,0.8-1.9,1.9
      	v11.6c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8v-9h1.5v9c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2V5.6c0-1.9,1.5-3.4,3.4-3.4
      	s3.4,1.5,3.4,3.4v11.6C16.5,19.7,14.5,21.8,12,21.8z"
      />
    )}

    {/* size: 20 */}
    {name === 'pencil' && (
      <path
        d="M16.1,0L1.6,14.5L0,20l5.5-1.6L20,3.9L16.1,0z M17.9,3.9l-1.3,1.3l-1.8-1.8l1.3-1.3L17.9,3.9z M3.7,14.5
      L13.8,4.4l1.8,1.8L5.5,16.3L3.7,14.5z M2.8,15.7l1.5,1.5l-2.1,0.6L2.8,15.7z"
      />
    )}

    {name === 'plus' && (
      <polygon
        points="20,14.5 15.5,14.5 15.5,10 14.5,10 14.5,14.5 10,14.5 10,15.5 14.5,15.5 14.5,20 15.5,20 15.5,15.5 
      20,15.5 "
      />
    )}

    {name === 'search' && (
      <>
        <path
          d="M11,5.5c3,0,5.5,2.5,5.5,5.5S14,16.5,11,16.5S5.5,14,5.5,11S8,5.5,11,5.5 M11,4c-3.9,0-7,3.1-7,7s3.1,7,7,7
        s7-3.1,7-7S14.9,4,11,4L11,4z"
        />
        <rect
          x="16.5"
          y="14"
          transform="matrix(0.7071 -0.7071 0.7071 0.7071 -7.0939 17.2321)"
          width="1.5"
          height="6.4"
        />
      </>
    )}

    {name === 'settings' && (
      <path
        d="M12,20.8c-0.7,0-1.4-0.1-2.1-0.3l-0.4-0.1v-2.6c-0.5-0.2-1-0.5-1.4-0.8l-2.2,1.3l-0.3-0.3c-1-1-1.7-2.3-2.1-3.6
	l-0.1-0.4l2.2-1.3c0-0.3-0.1-0.6-0.1-0.8c0-0.3,0-0.5,0.1-0.8L3.4,9.9l0.1-0.4c0.4-1.3,1.1-2.6,2.1-3.6l0.3-0.3l2.2,1.3
	C8.5,6.6,9,6.3,9.5,6.1V3.5l0.4-0.1c1.4-0.3,2.8-0.3,4.2,0l0.4,0.1v2.6c0.5,0.2,1,0.5,1.4,0.8l2.2-1.3l0.3,0.3c1,1,1.7,2.3,2.1,3.6
	l0.1,0.4l-2.2,1.3c0,0.3,0.1,0.6,0.1,0.8s0,0.5-0.1,0.8l2.2,1.3l-0.1,0.4c-0.4,1.4-1.1,2.6-2.1,3.6l-0.3,0.3l-2.2-1.3
	c-0.4,0.3-0.9,0.6-1.4,0.8v2.6l-0.4,0.1C13.4,20.8,12.7,20.8,12,20.8z M10.5,19.7c1,0.2,1.9,0.2,2.9,0v-2.5l0.3-0.1
	c0.6-0.2,1.2-0.6,1.7-1l0.3-0.2l2.1,1.2c0.6-0.8,1.2-1.6,1.5-2.6l-2.1-1.2l0.1-0.3c0.1-0.3,0.1-0.7,0.1-1c0-0.3,0-0.6-0.1-1
	l-0.1-0.3l2.1-1.2c-0.3-0.9-0.8-1.8-1.5-2.6l-2.1,1.2l-0.3-0.2c-0.5-0.4-1.1-0.8-1.7-1l-0.3-0.1V4.3c-1-0.2-2-0.2-2.9,0v2.5
	l-0.3,0.1C9.6,7.1,9,7.4,8.5,7.9L8.2,8.1L6.1,6.9C5.4,7.6,4.9,8.5,4.6,9.4l2.1,1.2L6.7,11c-0.1,0.3-0.1,0.7-0.1,1c0,0.3,0,0.7,0.1,1
	l0.1,0.3l-2.1,1.2c0.3,0.9,0.8,1.8,1.5,2.6l2.1-1.2l0.3,0.2c0.5,0.4,1.1,0.8,1.7,1l0.3,0.1V19.7z M12,15.1c-1.7,0-3.1-1.4-3.1-3.1
	c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1C15.1,13.7,13.7,15.1,12,15.1z M12,9.9c-1.2,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1
	s2.1-0.9,2.1-2.1S13.2,9.9,12,9.9z"
      />
    )}

    {name === 'subject' && (
      <g>
        <path
          d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M12,21c-5,0-9-4-9-9c0-5,4-9,9-9
		c5,0,9,4,9,9C21,17,17,21,12,21z"
        />
        <path
          d="M12.2,11.6c-1.1-0.2-1.9-0.5-1.9-1.3c0-0.7,0.7-1.2,1.6-1.2c1.1,0,1.8,0.6,1.9,1.4l1.2-0.5
		C14.8,8.8,13.6,8,12,8c-1.7,0-3,1-3,2.5c0,1.6,1.4,2.1,2.7,2.4c1.3,0.3,2.2,0.4,2.2,1.3c0,0.7-0.7,1.3-1.8,1.3
		c-1.2,0-2-0.6-2.2-1.4l-1.2,0.5c0.3,1.3,1.6,2.1,3.3,2.1c1.9,0,3.2-1.1,3.2-2.5C15.2,12.3,13.5,11.9,12.2,11.6z"
        />
      </g>
    )}

    {name === 'tracker' && (
      <g>
        <path
          d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M12,21c-5,0-9-4-9-9c0-5,4-9,9-9
		c5,0,9,4,9,9C21,17,17,21,12,21z"
        />
        <polygon points="9.1,10 11.5,10 11.5,16.9 12.8,16.9 12.8,10 15.3,10 15.3,8.8 9.1,8.8 	" />
      </g>
    )}

    {name === 'trash' && (
      <g>
        <rect x="13.1" y="8.7" width="1.5" height="9" />
        <rect x="9.4" y="8.7" width="1.5" height="9" />
        <rect x="8" y="2.2" width="8" height="1.5" />
        <path d="M20,5.2H4v1.5h1.2v15h13.5v-15H20V5.2z M17.2,20.2H6.8V6.8h10.5V20.2z" />
      </g>
    )}
  </svg>
);

export default Icon;
